import React from 'react';
import AppImages from '../Globals/AppImages';

function NotFound() {
    return (
        <div>
            <img src={AppImages.notFound404} alt="not found" />
        </div>
    );
}

export default NotFound;